/**
 * Sync theme product price with Seal Subscriptions purchase option.
 * When "Subscribe & save" is selected, main PDP price matches the Seal price.
 */
(function () {
  const PRICE_SELECTOR =
    '.ac-pdp-hero product-price .price-item--sale, .ac-pdp-hero product-price .price__regular > .price, .ac-pdp-hero product-price .price__regular .price';

  let sealObserver = null;
  let debounceTimer = null;
  let boundRoots = new WeakSet();

  function scheduleSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(syncFromSeal, 30);
  }

  function getActiveSealMoneyEl() {
    const active = document.querySelector(
      '.sealsubs-container .sls-option-container.sls-active'
    );
    if (!active) return null;

    return (
      active.querySelector('.sls-total-price .sls-price .money') ||
      active.querySelector('.sls-price .money') ||
      active.querySelector('.money')
    );
  }

  function getMainPriceEls() {
    return Array.from(document.querySelectorAll(PRICE_SELECTOR)).filter((el) => {
      return (
        el &&
        !el.closest('s') &&
        !el.classList.contains('compare-at-price') &&
        !el.classList.contains('price-item--regular')
      );
    });
  }

  function syncFromSeal() {
    const sealMoney = getActiveSealMoneyEl();
    if (!sealMoney) return;

    const nextText = (sealMoney.textContent || '').trim();
    if (!nextText) return;

    getMainPriceEls().forEach((el) => {
      if ((el.textContent || '').trim() !== nextText) {
        el.textContent = nextText;
      }
    });
  }

  function observeSeal(root) {
    if (sealObserver) sealObserver.disconnect();

    sealObserver = new MutationObserver(scheduleSync);
    sealObserver.observe(root, {
      attributes: true,
      attributeFilter: ['class', 'aria-checked', 'value'],
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function bindSealEvents(root) {
    if (!root || boundRoots.has(root)) {
      observeSeal(root);
      return;
    }
    boundRoots.add(root);

    root.addEventListener('change', scheduleSync, true);
    root.addEventListener(
      'click',
      function () {
        scheduleSync();
        setTimeout(syncFromSeal, 80);
        setTimeout(syncFromSeal, 200);
      },
      true
    );

    observeSeal(root);
  }

  function init() {
    const containers = document.querySelectorAll('.sealsubs-container');
    if (!containers.length) return false;

    // Auto-select the Monthly Plan (or second option) on initial load
    if (!window.sealMonthlySelected) {
      setTimeout(() => {
        const options = document.querySelectorAll('.sealsubs-container input[type="radio"]');
        // Option 0 is usually One-time, Option 1 is usually the first subscription (Monthly)
        if (options.length >= 2) {
          // Look for "Monthly" specifically, otherwise fallback to the second option
          let selected = false;
          options.forEach(opt => {
            const container = opt.closest('.sls-option-container');
            if (container && container.textContent.includes('Monthly')) {
              opt.click();
              selected = true;
            }
          });
          if (!selected) {
            options[1].click();
          }
        }
        window.sealMonthlySelected = true;
      }, 50); // Slight delay to ensure Seal has fully initialized its own listeners
    }

    containers.forEach(bindSealEvents);
    syncFromSeal();
    return true;
  }

  function waitForSeal() {
    if (init()) return;

    const waiter = new MutationObserver(function () {
      if (init()) waiter.disconnect();
    });
    waiter.observe(document.documentElement, { childList: true, subtree: true });
  }

  // After variant changes, theme replaces price HTML — re-apply Seal price
  document.addEventListener(
    'variant:update',
    function () {
      setTimeout(syncFromSeal, 50);
      setTimeout(syncFromSeal, 200);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForSeal);
  } else {
    waitForSeal();
  }
})();
